module.exports = __webpack_public_path__ + "img/zhidingicon.a76406ae.svg";